import { jsx as _jsx } from "react/jsx-runtime";
import Decimal from 'decimal.js';
import { Bank, Business, Coins, Document, Edit, Invoice, User } from 'seagull/icons';
import { getURLWithFullPageInvoice } from '~/components/FullPageInvoice/FullPageInvoice.utils';
import { routes } from '~/constants';
import { timeModel } from '~/models';
import { utils } from '~/utils';
export const notificationsTextsPath = 'components.inAppNotificationsDrawer.notifications';
export const getNotificationPresentationData = (notificationItem, texts)=>{
    switch(notificationItem.type){
        case 'relationship':
            {
                return getRelationshipPresentationData(notificationItem, texts);
            }
        case 'invoice':
            {
                return getInvoicePresentationData(notificationItem, texts);
            }
        case 'payout':
            {
                return getPayoutPresentationData(notificationItem, texts);
            }
        case 'user':
            {
                return getUserPresentationData(notificationItem, texts);
            }
        case 'business':
            {
                return getBusinessPresentationData(notificationItem, texts);
            }
    }
};
const getRelationshipPresentationData = (relationshipNotificationItem, texts)=>{
    const { type, id, customerName, clientName } = relationshipNotificationItem.relationship;
    const agreementPath = routes.agreement(id);
    const billingHubPath = routes.billingHub(id);
    switch(type){
        case 'approved':
            return {
                icon: /*#__PURE__*/ _jsx(Document, {}),
                content: texts.relationship.approved({
                    customerName,
                    clientName
                }),
                path: agreementPath,
                type
            };
        case 'adhocChargeApproved':
            return {
                icon: /*#__PURE__*/ _jsx(Coins, {}),
                content: texts.relationship.adhocChargeApproved({
                    customerName,
                    clientName
                }),
                path: billingHubPath,
                type
            };
        case 'approvedAmendments':
            return {
                icon: /*#__PURE__*/ _jsx(Edit, {}),
                content: texts.relationship.approvedAmendments({
                    customerName,
                    clientName
                }),
                path: agreementPath,
                type
            };
        case 'autoApprovedAmendments':
            return {
                icon: /*#__PURE__*/ _jsx(Edit, {}),
                content: texts.relationship.autoApprovedAmendments({
                    customerName,
                    clientName
                }),
                path: agreementPath,
                type
            };
        case 'stoppedAutoApproval':
            return {
                icon: /*#__PURE__*/ _jsx(Edit, {}),
                content: texts.relationship.stoppedAutoApproval({
                    customerName,
                    clientName
                }),
                path: agreementPath,
                type
            };
    }
};
const getInvoicePresentationData = (invoiceNotificationItem, texts)=>{
    const { type, id, relationshipId, formattedNumber } = invoiceNotificationItem.invoice;
    const invoicesPath = getURLWithFullPageInvoice({
        relationshipId,
        invoiceId: id
    });
    switch(type){
        case 'paymentFailed':
            return {
                icon: /*#__PURE__*/ _jsx(Invoice, {}),
                content: texts.invoice.paymentFailed({
                    formattedNumber
                }),
                path: invoicesPath,
                type
            };
        case 'invoiceIssuedRequiresApproval':
            return {
                icon: /*#__PURE__*/ _jsx(Invoice, {}),
                content: texts.invoice.invoiceIssuedRequiresApproval({
                    formattedNumber
                }),
                path: invoicesPath,
                type
            };
    }
};
const getPayoutPresentationData = (payoutNotificationItem, texts)=>{
    const { type, amount, arrivalDate } = payoutNotificationItem.payout;
    const payoutPath = "".concat(routes.payoutsDashboard);
    switch(type){
        case 'payoutCreated':
            return {
                icon: /*#__PURE__*/ _jsx(Coins, {}),
                content: texts.payout.payoutCreated({
                    amount: utils.formatDollarAmount(new Decimal(amount).div(100)),
                    arrivalDate: timeModel.formatDateWithTime(arrivalDate)
                }),
                path: payoutPath,
                type
            };
    }
};
const getUserPresentationData = (userNotificationItem, texts)=>{
    const { type, email, fullName } = userNotificationItem.user;
    const contactsPath = "".concat(routes.contacts, "?search=").concat(email);
    switch(type){
        case 'invalidEmail':
            return {
                icon: /*#__PURE__*/ _jsx(User, {}),
                content: fullName ? texts.user.invalidEmailWithName({
                    fullName: "".concat(fullName.first, " ").concat(fullName.last),
                    email
                }) : texts.user.invalidEmail({
                    email
                }),
                path: contactsPath,
                type
            };
    }
};
const getBusinessPresentationData = (businessNotificationItem, texts)=>{
    const { type } = businessNotificationItem.business;
    switch(type){
        case 'kycVerificationNeeded':
            return {
                icon: /*#__PURE__*/ _jsx(Business, {}),
                content: texts.business.kycVerificationNeeded(),
                path: routes.home,
                type
            };
        case 'kycFutureVerificationNeeded':
            return {
                icon: /*#__PURE__*/ _jsx(Business, {}),
                content: texts.business.kycFutureVerificationNeeded(),
                path: routes.home,
                type
            };
        case 'bankAccountMDVerificationStarted':
            {
                const { customerName } = businessNotificationItem.business.BankAccountMDVerificationStartedBusinessNotificationType;
                return {
                    icon: /*#__PURE__*/ _jsx(Bank, {}),
                    content: texts.business.bankAccountMDVerificationStarted({
                        customerName
                    }),
                    type
                };
            }
    }
};
